import { createAction } from 'redux-actions';

import {
  BOOK_APPOINTMENT,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_ERROR,
  UPDATE_BOOKING_INFO,
  UPDATE_BOOKING_INFO_SUCCESS,
  UPDATE_BOOKING_INFO_ERROR,
} from './type';

//Book onsite appointment slot
export const bookAppointmentAction = createAction(BOOK_APPOINTMENT);
export const bookAppointmentSuccessAction = createAction(
  BOOK_APPOINTMENT_SUCCESS,
);
export const bookAppointmentErrorAction = createAction(BOOK_APPOINTMENT_ERROR);

export const updateBookingInfoAction = createAction(UPDATE_BOOKING_INFO);
export const updateBookingInfoSuccessAction = createAction(
  UPDATE_BOOKING_INFO_SUCCESS,
);
export const updateBookingInfoErrorAction = createAction(
  UPDATE_BOOKING_INFO_ERROR,
);
